import dayjs from "dayjs";

const DIVISORS = [
  { seconds: 31536000, unit: "year" },
  { seconds: 2592000, unit: "month" },
  { seconds: 604800, unit: "week" },
  { seconds: 86400, unit: "day" },
  { seconds: 3600, unit: "hour" },
  { seconds: 60, unit: "minute" },
  { seconds: 1, unit: "second" },
] as const;

export const i18nextParseToRelative = (
  date: string | number | dayjs.Dayjs | Date,
  baseDate: string | number | dayjs.Dayjs | Date = dayjs(),
  formatParams: Record<string, unknown> = {},
) => {
  const diffInSeconds = dayjs(date).diff(baseDate) / 1000;
  const absDiff = Math.abs(diffInSeconds);

  const { unit, seconds } =
    DIVISORS.find((d) => absDiff >= d.seconds) ||
    // biome-ignore lint/style/noNonNullAssertion: DIVISORS always has at least one element
    DIVISORS[DIVISORS.length - 1]!;

  return {
    formatParams,
    range: unit,
    val: Math.round(diffInSeconds / seconds),
  };
};

export const i18nextParseToDate = (
  date: string | number | dayjs.Dayjs | Date,
  formatParams: Record<string, unknown> = {},
) => {
  return {
    formatParams,
    interpolation: { escapeValue: false },
    val: dayjs(date),
  };
};
